var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvcIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5383 15C20.1659 15 15 20.166 15 26.5384C15 32.9108 20.1659 38.0768 26.5383 38.0768C32.9107 38.0768 38.0766 32.9108 38.0766 26.5384C38.0766 20.166 32.9107 15 26.5383 15Z",
    fill: "#9AFF42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4621 15.0002C47.0897 15.0002 41.9238 20.1662 41.9238 26.5386C41.9238 32.9111 47.0897 38.077 53.4621 38.077C59.8346 38.077 65.0004 32.9111 65.0004 26.5386C65.0004 20.1662 59.8346 15.0002 53.4621 15.0002Z",
    fill: "#38383D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5383 41.9235C20.1659 41.9235 15 47.0894 15 53.4618C15 59.8343 20.1659 65.0002 26.5383 65.0002C32.9107 65.0002 38.0766 59.8343 38.0766 53.4618C38.0766 47.0894 32.9107 41.9235 26.5383 41.9235Z",
    fill: "#38383D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4621 41.9235H50.5776V47.6927V49.135V50.5773H49.1353H47.693H41.9238V53.4618V56.3464H47.693H49.1353H50.5776V57.7887V59.231V65.0002H53.4621H56.3467V59.231V57.7887V56.3464H57.789H59.2313H65.0004V53.4618V50.5773H59.2313H57.789H56.3467V49.135V47.6927V41.9235H53.4621Z",
    fill: "#9AFF42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.693 50.5773V49.135H43.3661C42.5696 49.135 41.9238 49.7807 41.9238 50.5773H47.693Z",
    fill: "#9AFF42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.693 50.5773H49.1353V49.135H47.693V50.5773Z",
    fill: "#9AFF42"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5776 50.5773V49.135H49.1353V50.5773H50.5776Z",
    fill: "#9AFF42"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5776 47.6927H49.1353V49.135H50.5776V47.6927Z",
    fill: "#9AFF42"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5776 47.6927V41.9235C49.781 41.9235 49.1353 42.5692 49.1353 43.3657V47.6927H50.5776Z",
    fill: "#9AFF42"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3467 59.231V65.0002C57.1433 65.0002 57.789 64.3545 57.789 63.5579V59.231H56.3467Z",
    fill: "#9AFF42"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3467 57.7887V59.231H57.789V57.7887H56.3467Z",
    fill: "#9AFF42"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.789 56.3464H56.3467V57.7887H57.789V56.3464Z",
    fill: "#9AFF42"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5776 57.7887V56.3464H49.1353V57.7887H50.5776Z",
    fill: "#9AFF42"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1353 59.231H50.5776V57.7887H49.1353V59.231Z",
    fill: "#9AFF42"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5776 65.0002V59.231H49.1353V63.5579C49.1353 64.3545 49.781 65.0002 50.5776 65.0002Z",
    fill: "#9AFF42"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.693 56.3464V57.7887H49.1353V56.3464H47.693Z",
    fill: "#9AFF42"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.693 56.3464H41.9238C41.9238 57.143 42.5696 57.7887 43.3661 57.7887H47.693V56.3464Z",
    fill: "#9AFF42"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3467 50.5773H57.789V49.135H56.3467V50.5773Z",
    fill: "#9AFF42"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2313 50.5773V49.135H57.789V50.5773H59.2313Z",
    fill: "#9AFF42"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2313 50.5773H65.0004C65.0004 49.7807 64.3547 49.135 63.5581 49.135H59.2313V50.5773Z",
    fill: "#9AFF42"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2313 56.3464V57.7887H63.5581C64.3547 57.7887 65.0004 57.143 65.0004 56.3464H59.2313Z",
    fill: "#9AFF42"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.789 56.3464V57.7887H59.2313V56.3464H57.789Z",
    fill: "#9AFF42"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.789 47.6927H56.3467V49.135H57.789V47.6927Z",
    fill: "#9AFF42"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3467 41.9235V47.6927H57.789V43.3657C57.789 42.5692 57.1433 41.9235 56.3467 41.9235Z",
    fill: "#9AFF42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvcIcon3);
export default __webpack_public_path__ + "static/media/svc_icon3.50a9348e53d5104177fbc724c8463b51.svg";
export { ForwardRef as ReactComponent };